namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_drafts_editor, {
		width: '42rem', flex: { basis: '42rem', grow: 0, shrink: 0 },
		Head: { flexWrap: 'nowrap', alignItems: 'center' },
		Title: { minWidth: 0, padding: 0, alignItems: 'center', overflow: 'hidden' },
		Name: { minWidth: 0, width: 0, flex: { basis: 0, grow: 1, shrink: 1 } },
		Text: { minWidth: 0, maxWidth: '100%' },
	})
}
